import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';

const AppInstructions = () => {
  return (
      <Row>
        <Col xs={12} md={6}>
          <h3>Instructions:</h3>
          <ol>
            <li>Select the project for which you want to collect data.</li>
            <li>From the assigned forms, select the form depending on the project requirement.</li>
            <li>You are ready to collect the data :)</li>
            <li>You can also view and edit the collected data by using the "completed forms" option.</li>
          </ol>
          <p>Happy data collection!</p>
        </Col>
      </Row>
  );
};

export default AppInstructions;
